import React from "react";
import styled from "styled-components";
import config from "app/envConfig";
import { collectorFullName } from "features/home/utils";

export const isNewDebtorSearchLayoutEnabled = config.aktosEnv !== "prod";

const StyledResult = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.4;
  padding: 0;
  min-width: 0;
`;

const StyledTopLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
`;

const StyledName = styled.span`
  font-weight: 600;
  color: rgba(0, 0, 0, 0.88);
  font-size: 12px;
`;

const StyledMeta = styled.span`
  color: rgba(0, 0, 0, 0.7);
  font-size: 11px;
`;

const StyledAccounts = styled.div`
  color: rgba(0, 0, 0, 0.7);
  font-size: 11px;
`;

export default function DebtorSearchResultLabel({ debtor }) {
  if (!isNewDebtorSearchLayoutEnabled) {
    return (
      <>
        {collectorFullName(debtor)} (Debtor ID: {debtor.id}, Account IDs: [
        {debtor.accountIds?.join(", ")}])
      </>
    );
  }

  const chips = [];
  if (debtor.externalId) {
    chips.push({ key: "ext", label: "External ID", value: debtor.externalId });
  } else {
    chips.push({ key: "id", label: "Debtor ID", value: debtor.id });
  }
  // Future identifier chips (e.g., SSN last 4, DOB) plug in here:
  // if (debtor.ssnLast4) chips.push({ key: "ssn", label: "SSN", value: `•••${debtor.ssnLast4}` });
  // if (debtor.dob) chips.push({ key: "dob", label: "DOB", value: formatDate(debtor.dob) });

  return (
    <StyledResult>
      <StyledTopLine>
        <StyledName>{debtor.name || "—"}</StyledName>
        <StyledMeta>
          {chips.map((chip, idx) => (
            <React.Fragment key={chip.key}>
              {idx > 0 && " · "}
              {chip.label}: {chip.value}
            </React.Fragment>
          ))}
        </StyledMeta>
      </StyledTopLine>
      <StyledAccounts>
        Account IDs: {debtor.accountIds?.length ? debtor.accountIds.join(", ") : "—"}
      </StyledAccounts>
    </StyledResult>
  );
}
